import { Column, Columns, Flex, Text } from "@dna/react";
import { makeStyles } from "@material-ui/core";
import React from "react";
import { MessageType } from "../common/constants";
import { FlatButton } from "../common/FlatButton";
import { SuccessBanner } from "../layout/SuccessBanner";
import { WarningBanner } from "../layout/WarningBanner";
import styles from "./SelectOrganisation.module.scss";

export const MapExternalUserMessageBox = (props: 
  {type: any, 
    titleText:string,
     bodyText: string, 
     isRegistrationForm?:boolean, 
     organisationNames?: string[], 
     onClose?: any, 
     redirectToHome?: any,
     onReviewClick?: any,
     reviewAttempts?: number}) => {

  return (
       <React.Fragment>
      {
     props.type == MessageType.Warning && 
    (<React.Fragment>
        <div className={styles.fullContent}>
          <div>
             <WarningBanner text={props.titleText}></WarningBanner> 
            <p></p><br></br>
            <div className={styles.header}>
             {props.bodyText}
              <p></p>
            </div>
          </div>
        </div>
        <hr className={styles.divider} />
          {!props.isRegistrationForm && (<FlatButton
            type="button"
            kind="primary"
            onPress={props.onClose}
            css={{
              width: 110,
              alignSelf: "flex-end",
              marginBottom:15,
              marginStart:15,
              marginEnd:15
            }}>
            Exit
          </FlatButton>)}

          {props.isRegistrationForm && 
             (<Columns>
               <Column>
                 <FlatButton
                   type="button"
                   kind="primary"
                   onPress={props.onClose}
                   css={{
                     width: 110,
                     alignSelf: "flex-start",
                     marginBottom:15,
                     marginStart:15
                   }}>
                   Exit
                 </FlatButton>
               </Column>
               <Column width="content">
                 <FlatButton
                   type="button"
                   kind="primary"
                   onPress={props.onReviewClick}
                   isDisabled={props.reviewAttempts === 3}
                   css={{
                     width: 110,
                     alignSelf: "flex-end",
                     marginBottom:15,
                     marginEnd:15
                   }}>
                   Review details
                 </FlatButton>
               </Column>
             </Columns>     
          )}
          </React.Fragment>
      )
      }

      {
      props.type == MessageType.Success && 
        (
          <React.Fragment>
              <div className={styles.fullContent}>
              <div>
              <SuccessBanner text={props.titleText}></SuccessBanner>
              <p></p><br></br>
              
                 <div className={styles.header}>
                 {props.bodyText}
                </div>
                <ul>
                {props.organisationNames && props.organisationNames.map(function(name, index){
                    return <li key={ index }>{name}</li>;
                  })}
                </ul> 
              </div>
            </div>
            <hr className={styles.divider} />
            <FlatButton
              type="button"
              kind="primary"
              onPress={props.redirectToHome}
              css={{
                width: 110,
                alignSelf: "flex-end",
                marginBottom:15,
                marginEnd:15
              }}>
              OK
            </FlatButton>
            </React.Fragment>
        )
          }
           </React.Fragment>
    );
}